@if (isOpen()) {
  <div class="cos-modal" role="dialog" aria-modal="true" aria-labelledby="cosTitle">
    <div class="cos-modal__card">
      <h4 id="cosTitle" class="cos-modal__title">Select options to send to the customer</h4>
      <p class="cos-modal__hint">The customer will pick one. Options you don't send stay open.</p>
      <ul class="cos-modal__list">
        @for (choice of choices(); track choice.estimateKey) {
          <li>
            <label class="cos-modal__row" [class.cos-modal__row--on]="isTicked(choice.estimateKey)">
              <input
                type="checkbox"
                class="cos-modal__check"
                [checked]="isTicked(choice.estimateKey)"
                (change)="toggle(choice.estimateKey)"
              />
              <span class="cos-modal__label">{{ choice.label }}</span>
              <span class="cos-modal__total">{{ choice.total | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
            </label>
          </li>
        }
      </ul>
      <div class="cos-modal__foot">
        <button type="button" class="cos-btn" (click)="cancel()">Cancel</button>
        <button type="button" class="cos-btn cos-btn--go" [disabled]="!canContinue()" (click)="continue()">
          Continue
        </button>
      </div>
    </div>
  </div>
}
